import React from "react";

export default function Footer() {
  return (
    <footer className="lk-footer">
      <div className="lk-container lk-footer-inner">
        <div className="lk-brand">LeadKey AI</div>
        <nav className="lk-footer-nav" aria-label="Footer">
          <a href="#features">Features</a>
          <a href="#how">How It Works</a>
          <a href="#faq">FAQ</a>
          <a href="mailto:hello@leadkey.ai">Contact</a>
        </nav>
        <div className="lk-small">© {new Date().getFullYear()} LeadKey AI</div>
      </div>
    </footer>
  );
}
